import { useEffect } from 'react'

export default function SeoHead({ title, description, isHome = false, image }) {
  useEffect(() => {
    // Determine title according to specification
    let fullTitle = 'Emmerske Efterskole'
    if (!isHome && title) {
      if (title.includes('Emmerske Efterskole')) {
        fullTitle = title
      } else {
        fullTitle = `${title} - Emmerske Efterskole`
      }
    }

    document.title = fullTitle

    // Update meta description
    const descText = description || 'Emmerske Efterskole er en specialiseret efterskole for ordblinde i Sønderjylland med plads til 95 elever i 8., 9. og 10. klasse. Her er det rart at være og lære.'
    
    let metaDesc = document.querySelector('meta[name="description"]')
    if (!metaDesc) {
      metaDesc = document.createElement('meta')
      metaDesc.setAttribute('name', 'description')
      document.head.appendChild(metaDesc)
    }
    metaDesc.setAttribute('content', descText)

    // OpenGraph Title & Description
    let ogTitle = document.querySelector('meta[property="og:title"]')
    if (!ogTitle) {
      ogTitle = document.createElement('meta')
      ogTitle.setAttribute('property', 'og:title')
      document.head.appendChild(ogTitle)
    }
    ogTitle.setAttribute('content', fullTitle)

    let ogDesc = document.querySelector('meta[property="og:description"]')
    if (!ogDesc) {
      ogDesc = document.createElement('meta')
      ogDesc.setAttribute('property', 'og:description')
      document.head.appendChild(ogDesc)
    }
    ogDesc.setAttribute('content', descText)

    // OG Image
    const ogImgUrl = image || 'https://assets.auxodev.dk/assets/e40f0695-6390-4586-b67e-d6f4d574a533/emmerske-efterskole-11_b9da62a8.jpg'
    let ogImg = document.querySelector('meta[property="og:image"]')
    if (!ogImg) {
      ogImg = document.createElement('meta')
      ogImg.setAttribute('property', 'og:image')
      document.head.appendChild(ogImg)
    }
    ogImg.setAttribute('content', ogImgUrl)

  }, [title, description, isHome, image])

  return null
}
